import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table, Pagination, Col, Row, Input, Select, Button } from "antd";
import moment from "moment";
import { strings } from "../../helpers";

const { Search } = Input;
const { Option } = Select;

export default class UsersDetailsView extends Component {
  /**
   * @function showServicePeriodInIST
   * @description This function shows service date range in IST format
   */
  showServicePeriodInIST = (startDate, endDate) => {
    if (startDate && endDate) {
      const createdAtIST = new Date(startDate).toLocaleString("es-CL", {
        timeZone: "Asia/Kolkata"
      });
      const expireByIST = new Date(endDate).toLocaleString("es-CL", {
        timeZone: "Asia/Kolkata"
      });

      return <div>{`${createdAtIST} to ${expireByIST}`}</div>;
    }
  };

  render() {
    const {
      userDetails,
      userSubscription,
      navigateToDoctorDetails,
      userPayments,
      handleUserStatus,
      userStatus,
      showAddSubscriptionModal,
      toggleSubscriptionModal,
      handleSNSDeletion,
      devices,
      fetchingDevices,
      handleShowDeviceDetail,
      handleDeleteSNSToken,
      totalDevicePages,
      devicePageNo,
      allDevices,
      onDevicesPageChange,
      deviceType,
      handleDeviceChange
    } = this.props;
    const userDetailss = [
      {
        title: "phone number",
        key: "phone_number",
        align: "left",
        render: record => <div>{record.phone_number || "--"}</div>
      },
      {
        title: "Verified At",
        key: "verified_at",
        align: "left",
        render: record => (
          <div>
            {moment(record.verified_at).format("DD-MM-YYYY") +
              " " +
              moment(record.verified_at).format("LT") || "--"}
          </div>
        )
      },
      {
        title: "Email",
        key: "email",
        align: "left",
        render: record => <div>{record.email || "--"}</div>
      },
      {
        title: "Account",
        key: "account",
        align: "left",
        render: record => <div>{record.account || "--"}</div>
      },
      {
        title: "Status",
        key: "status",
        align: "left",
        render: record => (
          <div>
            <Select
              // defaultValue={record.status}
              value={userStatus ? userStatus : record.status}
              style={{ width: 120 }}
              onChange={handleUserStatus}
            >
              <Option value="ACTIVE">Active</Option>
              <Option value="INACTIVE">Inactive</Option>
              <Option value="BLOCKED">Blocked</Option>
            </Select>
          </div>
        )
      },

      {
        title: "Platform",
        key: "platform",
        align: "left",
        render: record => <div>{record.platform || "--"}</div>
      }
    ];
    const userAccounts = [
      {
        title: "Email",
        key: "email",
        align: "left",
        render: record => <div>{record.email || "--"}</div>
      },
      {
        title: "Account Type",
        key: "account_type",
        align: "left",
        render: record => <div>{record.account_type || "--"}</div>
      },
      {
        title: "Role",
        key: "role",
        align: "left",
        render: record => <div>{record.role || "owner"}</div>
      },
      {
        title: "Account Name",
        align: "left",
        key: "plan",

        render: record => {
          const name = record.account_type;
          const nameOne = record[`${name}_name`];
          const nameThree = record[`${name}_id`];
          const url = navigateToDoctorDetails(record.account_type, nameThree);

          return record.account_type === "clinic" ||
            record.account_type === "lab" ||
            record.account_type === "pharmacy" ||
            record.account_type === "doctor" ? (
            <Link to={`${url}`}>{nameOne || "--"}</Link>
          ) : (
            <div>{nameOne || "--"}</div>
          );
        }
      }
    ];
    const userSubscriptions = [
      {
        title: "Plan Name",
        key: "plan",
        align: "left",
        render: record => <div>{record.plan.name || "--"}</div>
      },
      {
        title: "Plan Amount",
        key: "plan",
        align: "right",
        render: record => (
          <div>
            {"₹ "} {record.plan.amount || "--"}
          </div>
        )
      },
      {
        title: "Frequency",
        key: "plan",
        align: "left",
        render: record => <div>{record.plan.period || "--"}</div>
      },
      {
        title: "Service Period",
        key: "period",
        align: "left",
        render: record =>
          this.showServicePeriodInIST(record.created_at, record.expire_by)
      },
      {
        title: "Status",
        key: "billing_subscription_status",
        align: "left",
        render: record => (
          <div>{record.billing_subscription_status || "--"}</div>
        )
      }
    ];
    const userBilling = [
      {
        title: "Invoice No.",
        key: "invoice",
        align: "left",
        render: record => (
          <div>
            {(record.invoices &&
              record.invoices.length > 0 &&
              record.invoices[0].unique_id) ||
              "--"}
          </div>
        )
      },
      {
        title: "Date",
        key: "date",
        align: "left",
        render: record => (
          <div>{moment(record.created_at).format("DD-MM-YYYY") || "--"}</div>
        )
      },
      {
        title: "Plan",
        key: "serviceDetail",
        align: "left",
        render: record => (
          <div>
            {(record.invoices &&
              record.invoices.length > 0 &&
              record.invoices[0].payload &&
              record.invoices[0].payload.line_items &&
              record.invoices[0].payload.line_items.length > 0 &&
              record.invoices[0].payload.line_items[0].name) ||
              "--"}
          </div>
        )
      },
      {
        title: "description",
        key: "description",
        align: "left",
        render: record => <div>{record.description || "--"}</div>
      },
      {
        title: "Service Period",
        key: "period",
        align: "left",
        render: record => (
          <div>
            {this.showServicePeriodInIST(
              record.current_start,
              record.current_end
            )}
          </div>
        )
      },
      {
        title: "Method",
        key: "method",
        align: "left",
        render: record => <div>{record.method || "--"}</div>
      },
      {
        title: "Already Paid",
        key: "amount",
        align: "right",
        render: record => (
          <div>
            {"₹ "}
            {record.already_paid || "--"}
          </div>
        )
      },
      {
        title: "Promo Code",
        key: "invoice",
        align: "left",
        render: record => <div>{record.promo_code_name || "--"}</div>
      },
      {
        title: "Discount",
        key: "amount",
        align: "right",
        render: record => (
          <div>
            {"₹ "}
            {record.discount || "--"}
          </div>
        )
      },
      {
        title: "Paid",
        key: "amount",
        align: "right",
        render: record => (
          <div>
            {"₹ "}
            {record.amount || "--"}
          </div>
        )
      }
    ];

    const userDevices = [
      {
        title: "ID",
        align: "left",
        key: "id",
        render: record => (
          <a href="" onClick={e => handleShowDeviceDetail(e, record)}>
            {record.id}
          </a>
        )
      },
      {
        title: "App type",
        align: "left",
        dataIndex: "app_type",
        key: "app_type"
      },
      {
        title: "Version",
        align: "left",
        dataIndex: "app_version",
        key: "app_version"
      },
      {
        title: "Created at",
        align: "left",
        render: record => (
          <div>{moment(record.created_at).format("DD MMM, YYYY")}</div>
        )
      },
      {
        title: "Updated at",
        align: "left",
        render: record => (
          <div>{moment(record.updated_at).format("DD MMM, YYYY")}</div>
        )
      },
      {
        title: "Type",
        align: "left",
        dataIndex: "device_type",
        key: "device_type"
      },
      {
        title: "Device version",
        align: "left",
        dataIndex: "device_version",
        key: "device_version"
      },
      {
        title: "",
        align: "left",
        key: "actions",
        render: record => (
          <div>
            <a href="" onClick={e => handleDeleteSNSToken(e, record)}>
              Delete
            </a>
          </div>
        )
      }
    ];

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.userDetails}
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x mt-20">
            <Table
              columns={userDetailss}
              dataSource={userDetails && [userDetails]}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.userAccounts}
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x ">
            <Table
              // onRowClick={record => {
              //   const name = record.account_type;
              //   const nameOne = record[`${name}_id`];
              //   navigateToDoctorDetails(record.account_type, nameOne);
              // }}
              columns={userAccounts}
              dataSource={
                userDetails &&
                userDetails.user_accounts &&
                userDetails.user_accounts
              }
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.userSubscription}
            </Col>
            <Col>
              <Button type="primary" onClick={toggleSubscriptionModal}>
                Add Manual Subscription
              </Button>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x mt-20">
            <Table
              columns={userSubscriptions}
              dataSource={userSubscription}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>

        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.billingDetail}
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x mt-20">
            <Table
              columns={userBilling}
              dataSource={userPayments}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>

        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              User devices
            </Col>
            <Col>
              <Select
                value={deviceType}
                style={{ width: 120, marginRight: 10 }}
                onChange={handleDeviceChange}
              >
                <Option value="all">All</Option>
                <Option value="android">Android</Option>
                <Option value="ios">IOS</Option>
              </Select>
              <Button type="primary" onClick={handleSNSDeletion}>
                Delete All SNS
              </Button>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x mt-20">
            <Table
              columns={userDevices}
              dataSource={devices}
              pagination={false}
              rowKey="id"
              loading={fetchingDevices}
            />

            <div className="pagination-wrapper">
              {allDevices > 10 && (
                <div className="total-results-wrap">
                  <span className="result-count">{allDevices}</span>
                  {allDevices > 1 ? strings.results : strings.result}
                </div>
              )}
              {allDevices > 10 && (
                <Pagination
                  total={allDevices}
                  current={devicePageNo}
                  onChange={onDevicesPageChange}
                  pageSize={10}
                  defaultCurrent={devicePageNo}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
